import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _classPrivateFieldInitSpec from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Enum, Struct } from '@polkadot/types-codec';
import { objectSpread } from '@polkadot/util';
import { sign as _sign } from "../util.js";
/**
 * @name GenericExtrinsicPayloadV4
 * @description
 * A signing payload for an [[Extrinsic]]. For the final encoding, it is
 * variable length based on the contents included
 */

var _signOptions = /*#__PURE__*/new WeakMap();

export var GenericExtrinsicPayloadV4 = /*#__PURE__*/function (_Struct) {
  _inherits(GenericExtrinsicPayloadV4, _Struct);

  var _super = _createSuper(GenericExtrinsicPayloadV4);

  function GenericExtrinsicPayloadV4(registry, value) {
    var _this;

    _classCallCheck(this, GenericExtrinsicPayloadV4);

    _this = _super.call(this, registry, objectSpread({
      method: 'Bytes'
    }, registry.getSignedExtensionTypes(), registry.getSignedExtensionExtra()), value); // Do detection for the type of extrinsic, in the case of MultiSignature
    // this is an enum, in the case of AnySignature, this is a Hash only
    // (which may be 64 or 65 bytes)

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _signOptions, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(_assertThisInitialized(_this), _signOptions, {
      withType: registry.createTypeUnsafe('ExtrinsicSignature', []) instanceof Enum
    });

    return _this;
  }
  /**
   * @description Returns a breakdown of the hex encoding for this Codec
   */


  _createClass(GenericExtrinsicPayloadV4, [{
    key: "inspect",
    value: function inspect() {
      return _get(_getPrototypeOf(GenericExtrinsicPayloadV4.prototype), "inspect", this).call(this, {
        method: true
      });
    }
    /**
     * @description The block [[Hash]] the signature applies to (mortal/immortal)
     */

  }, {
    key: "blockHash",
    get: function get() {
      return this.getT('blockHash');
    }
    /**
     * @description The [[ExtrinsicEra]]
     */

  }, {
    key: "era",
    get: function get() {
      return this.getT('era');
    }
    /**
     * @description The genesis [[Hash]] the signature applies to (mortal/immortal)
     */

  }, {
    key: "genesisHash",
    get: function get() {
      return this.getT('genesisHash');
    }
    /**
     * @description The [[Bytes]] contained in the payload
     */

  }, {
    key: "method",
    get: function get() {
      return this.getT('method');
    }
    /**
     * @description The [[Index]]
     */

  }, {
    key: "nonce",
    get: function get() {
      return this.getT('nonce');
    }
    /**
     * @description The specVersion for this signature
     */

  }, {
    key: "specVersion",
    get: function get() {
      return this.getT('specVersion');
    }
    /**
     * @description The tip [[Balance]]
     */

  }, {
    key: "tip",
    get: function get() {
      return this.getT('tip');
    }
    /**
     * @description The transactionVersion for this signature
     */

  }, {
    key: "transactionVersion",
    get: function get() {
      return this.getT('transactionVersion');
    }
    /**
     * @description
     * The (optional) asset id for this signature for chains that support transaction fees in assets
     */

  }, {
    key: "assetId",
    get: function get() {
      return this.getT('assetId');
    }
    /**
     * @description Sign the payload with the keypair
     */

  }, {
    key: "sign",
    value: function sign(signerPair) {
      // NOTE The `toU8a({ method: true })` argument is absolutely critical, we
      // don't want the method (Bytes) to have the length prefix included. This
      // means that the data-as-signed is un-decodable, but is also doesn't need
      // the extra information, only the pure data (and is not decoded) ...
      // The same applies to V1..V3, if we have a V5, carrythis comment
      return _sign(this.registry, signerPair, this.toU8a({
        method: true
      }), _classPrivateFieldGet(this, _signOptions));
    }
  }]);

  return GenericExtrinsicPayloadV4;
}(Struct);